angular.module("genericContacts.components", [])
    .component("genericContacts", {
        templateUrl: "ng/components/genericContacts/genericContacts.view.html",
        bindings: {
            model: "=",
            id: "=",
            title: "=",
            noteIsVisible: "=",
            addIsVisible: "=",
            cfIsVisible: "=",
            componentIsOk: "&",
            componentIsNotOk: "&",
            initialTabIndex: "=",
            typeName: "="
        },
        controllerAs: "genericContactsCtrl",
        controller: GenericContactsController,
    });

function GenericContactsController(Riferimenti) {
    var self = this;

    self.$onInit = function () {
        self.supportModel = {
            initialIndex: 0,
            riferimentiList: [],
            loaderRemove: []
        };

        self.supportModel.initialIndex = self.initialTabIndex || 0;
        var rif = Riferimenti.build(Riferimenti.build({
            id: self.id
        }));
        self.supportModel.riferimentiList.push(rif);

        checkValidation();

    };

    self.$onChanges = function (changes) {
        self.supportModel = {
            initialIndex: 0
        };
    }

    self.handleChange = function (property, value) {
        if (property) {
            if (property == 'note') {
                self.model[property] = value && value.replace(/[\u0000-\u001f]/gi, '')
                    .replace(/[\u0080-\u009f]/gi, '')
                    .replace(/[\u0100-\uffff]/gi, '');
            } else {
                self.model[property] = value;
            }

            self.onStructureChanges({
                finContactsStructure: self.model,
            });
        }
    };

    self.handleRifChange = function (type, property, value) {
        switch (type) {
            case "note":
                self.model[property] = value && value.replace(/[\u0000-\u001f]/gi, '')
                    .replace(/[\u0080-\u009f]/gi, '')
                    .replace(/[\u0100-\uffff]/gi, '');
                break;
            case "client":
                self.supportModel.client.id = "CLIENTE";
                self.supportModel.client[property] = value;

                var index = self.model.riferimenti.findIndex(function (el) {
                    return el.id == self.supportModel.client.id;
                });

                if (index != -1) {
                    self.model.riferimenti.splice(index, 1);
                }
                self.model.riferimenti.push(
                    Riferimenti.build(self.supportModel.client)
                );
                break;

            default:
                break;
        }
        validationComponent();

        self.onStructureChanges({
            finContactsStructure: self.model,
        });
    };

    self.addContact = function () {
        var rif = Riferimenti.build(Riferimenti.build({
            id: self.id
        }));
        self.supportModel.riferimentiList.push(rif);
    }

    self.removeContact = function (index) {
        self.supportModel.loaderRemove[index] = true;
        self.supportModel.riferimentiList.splice(index, 1);
        self.supportModel.loaderRemove[index] = true;
    }

    var validationComponent = function () {
        if (self.supportModel.client &&
            self.supportModel.client.email &&
            self.supportModel.client.telefono &&
            self.supportModel.client.description
        ) {
            self.validityCustomer({
                validity: true,
            });
        } else {
            self.validityCustomer({
                validity: false,
            });
        }

        checkValidation();
    }

    var checkValidation = function () {
        var client = false;
        //condizione base 
        client = self.supportModel.client &&
            self.supportModel.client.email &&
            self.supportModel.client.telefono &&
            self.supportModel.client.description;

        if (client) {
            self.componentIsOk();
        } else {
            self.componentIsNotOk();
        }
    }
}